// login-customer-token.js

document.addEventListener('DOMContentLoaded', function() {
  const loginForm = document.querySelector('form.customer-login');

  if (!loginForm) return;

  loginForm.addEventListener('submit', async function(event) {
    event.preventDefault(); // デフォルトの送信を止める

    const email = loginForm.querySelector('input[name="customer[email]"]').value;
    const password = loginForm.querySelector('input[name="customer[password]"]').value;

    if (!email || !password) {
      alert('メールアドレスとパスワードを入力してください');
      return;
    }

    try {
      const token = await getCustomerAccessToken(email, password);
      if (token) {
        window.customerAccessToken = token;
        localStorage.setItem('customerAccessToken', token);
        console.log('ログイン成功！customerAccessToken:', token);
        loginForm.submit(); // トークン取得できたら本来のログイン処理
      } else {
        alert('ログインに失敗しました');
      }
    } catch (error) {
      console.error('エラー:', error);
      alert('ログインに失敗しました');
    }
  });
});

// Storefront APIを使ってcustomerAccessTokenを発行
async function getCustomerAccessToken(email, password) {
  const query = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `;

  const variables = {
    input: {
      email: email,
      password: password,
    }
  };

  const response = await fetch('/api/2023-04/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'f7c19a54ea00c254d56cb079bf487ff3',
    },
    body: JSON.stringify({ query: query, variables: variables })
  });

  const result = await response.json();
  console.log('Storefront API result:', result);

  if (result.data.customerAccessTokenCreate.customerAccessToken) {
    return result.data.customerAccessTokenCreate.customerAccessToken.accessToken;
  } else {
    console.error('Login error:', result.data.customerAccessTokenCreate.customerUserErrors);
    return null;
  }
}
